module.exports = __webpack_public_path__ + "img/smartdraw_text_tutorial_button.5e7672e2.jpg";